<smallstack-icon
  alias="addWidget"
  size="48"
  style="cursor: pointer"
  (click)="openWidgetLibrary()"
  data-test="cms-add-widget-btn"
  class="smallstack-widget-all-pointer-events text-primary"
  color="text-primary"
></smallstack-icon>
